import { buildSortEventsPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateSortEvents = async ({
  workflow,
  events,
  stream = true,
  onChunkReceived,
  abortController
}) => {
  if (!events?.length) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildSortEventsPrompt({ events, stream })

  try {
    if (stream) {
      const response = await streamJsonResponses({
        messages,
        aiVersion: workflow.aiVersion,
        onChunkReceived,
        signal: abortController?.signal
      })

      return [response, messages]
    } else {
      const response = await fetchJsonResponse({
        messages,
        aiVersion: workflow.aiVersion,
        signal: abortController?.signal
      })

      return response || null
    }
  } catch (error) {
    return null
  }
}
